import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";
import {reduceMinistryCollabs} from '../../helpers/feedbackHelpers';
import {getGroupIcons} from "../../helpers/groupHelper";
import Defines from "../../Defines";

class ScoreHistory extends Component {
  static propTypes = {
    ministerie: PropTypes.string,
    round: PropTypes.number
  };

  render() {
    const {gameState, gameStateInput, round, ministerie, schoolClass} = this.props;
    if (!gameStateInput.states[round] || round === 0 || gameState.currentRound === round || round >= gameState.currentRound) return <span/>;

    const sum =  gameState.Rounds[round].gameStateSum;
    const myInput = gameStateInput.states[round][gameStateInput.groupId] || {};

    let globas = 0;
    if (myInput.ministerieGlobaVerdeling && myInput.ministerieGlobaVerdeling[ministerie]) {
      globas = myInput.ministerieGlobaVerdeling[ministerie];
    }
    return (
      <div className="score-history-row">
        <div className={reduceMinistryCollabs(ministerie, gameStateInput, round).length > 0 || Defines.i18nMinistries.includes(ministerie) ? 'round' : 'round big'}>
          {__('sim_ronde')} {round}:
        </div>
        <div content={`${globas} ${__('sim_miljard')}`} className={`globas white-shadow-text ${!Defines.i18nMinistries.includes(ministerie) ? 'big' : ''}`}>
          {globas} {__('sim_miljard')}
        </div>
        {reduceMinistryCollabs(ministerie, gameStateInput, round).length > 0 || Defines.i18nMinistries.includes(ministerie) ?
          <div className={'collaboration history-collaborations'}>
            {getGroupIcons(reduceMinistryCollabs(ministerie, gameStateInput, round), schoolClass.Groups)
              .map((img, index) => <img key={index} src={img} alt={'gameState-icon'}/>)}
          </div> : ''
        }

        <div content={`${sum[`${ministerie}_points_raw`]} ${__('sim_punten').toLowerCase()}`} className={`points white-shadow-text ${!Defines.i18nMinistries.includes(ministerie) ? 'big' : ''}`}>
          {sum[`${ministerie}_points_raw`]} {__('sim_punten').toLowerCase()}
        </div>
      </div>
    )
  }
}

export default connect(({gameState, gameStateInput, schoolClass}) => ({gameState, gameStateInput, schoolClass}))(ScoreHistory);



// WEBPACK FOOTER //
// ./src/components/elements/ScoreHistory.js